import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Navbar.css';
import Logo from './logo.png';
import { useCart } from '../elementsui/CartContext';

function Navbar() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const { totalItems, fetchCart } = useCart();
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const toggleSidebar = () => {
    setSidebarOpen(prev => {
      console.log('Sidebar toggled:', !prev);
      document.body.style.overflow = !prev ? 'hidden' : 'auto';
      return !prev;
    });
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
    console.log('Sidebar closed');
    document.body.style.overflow = 'auto';
  };

  useEffect(() => {
    closeSidebar();
  }, [location.pathname]);

  useEffect(() => {
    if (token) {
      fetchCart();
    }
  }, [token, fetchCart]);

  const handleSearchInput = async (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setIsSearching(true);

    if (query.trim() === '') {
      setSuggestions([]);
      setIsSearching(false);
      return;
    }

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/products/search?q=${query}`);
      console.log('Search response:', response.data); // Debug
      setSuggestions(response.data.products || []);
    } catch (error) {
      console.error('Search error:', error.message, error.response?.data); // Enhanced debug
      setSuggestions([]);
    } finally {
      setIsSearching(false);
    }
  };

  const handleSuggestionClick = (productId) => {
    setSearchQuery('');
    setSuggestions([]);
    setIsSearching(false);
    navigate(`/product/${productId}`);
    closeSidebar();
  };

  const highlightMatch = (name, query) => {
    const regex = new RegExp(`(${query})`, 'gi');
    return name.replace(regex, '<span class="highlight">$1</span>');
  };

  return (
    <>
      <header className="nav-wrapper">
        <nav className="nav-main">
          <div className="container">
            <button
              className="sidebar-toggle border-0"
              type="button"
              onClick={toggleSidebar}
              aria-label="Toggle sidebar"
            >
              <i className="bi bi-list fs-3"></i>
            </button>

            <Link className="nav-logo" to="/">
              <img src={Logo} alt="binzal branding-logo" className="logo-img" />
            </Link>

            <div className="search-container desktop-search">
              <div className="search-group">
                <span className="search-icon">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search For Grocery, Vegetables, Fruits, And More"
                  value={searchQuery}
                  onChange={handleSearchInput}
                />
              </div>
              {searchQuery.trim() !== '' && (
                <div className="search-suggestions">
                  {isSearching ? (
                    <div className="suggestion-item">Searching...</div>
                  ) : suggestions.length > 0 ? (
                    suggestions.map((product) => (
                      <div
                        key={product._id}
                        className="suggestion-item"
                        onClick={() => handleSuggestionClick(product._id)}
                        dangerouslySetInnerHTML={{
                          __html: highlightMatch(product.name, searchQuery),
                        }}
                      />
                    ))
                  ) : (
                    <div className="suggestion-item suggestion-not-found">
                      Not found :)
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="nav-actions">
              <Link className="nav-action" to="/cart">
                <i className="bi bi-cart3 fs-4"></i>
                {totalItems !== null && totalItems > 0 && (
                  <span className="badge bg-success ms-1">{totalItems}</span>
                )}
                <span className="action-text">Cart</span>
              </Link>
              <Link className="nav-action" to={token ? '/account' : '/login'}>
                <i className="bi bi-person-fill fs-4"></i>
                <span className="action-text">Account</span>
              </Link>
            </div>
          </div>
        </nav>

        <section className="search-section mobile-search nav-main">
          <div className="container">
            <div className="search-container">
              <div className="search-group">
                <span className="search-icon">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="search-input"
                  placeholder="What Are You Looking For?"
                  value={searchQuery}
                  onChange={handleSearchInput}
                />
              </div>
              {searchQuery.trim() !== '' && (
                <div className="search-suggestions">
                  {isSearching ? (
                    <div className="suggestion-item">Searching...</div>
                  ) : suggestions.length > 0 ? (
                    suggestions.map((product) => (
                      <div
                        key={product._id}
                        className="suggestion-item"
                        onClick={() => handleSuggestionClick(product._id)}
                        dangerouslySetInnerHTML={{
                          __html: highlightMatch(product.name, searchQuery),
                        }}
                      />
                    ))
                  ) : (
                    <div className="suggestion-item suggestion-not-found">
                      Not found :)
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </section>

        <section className="nav-links-section">
          <div className="container">
            <ul className="nav-links">
              <li><Link className="nav-link" to="/">Home</Link></li>
              <li><Link className="nav-link" to="/category">binzal Combo</Link></li>
              <li><Link className="nav-link" to="/fruits-vegetables">All Vegetables</Link></li>
              <li><Link className="nav-link" to="/my-orders">My Orders</Link></li>
              <li><Link className="nav-link" to="/policy">Privacy Policy</Link></li>
              <li><Link className="nav-link" to="/contact">Contact Us</Link></li>
            </ul>
          </div>
        </section>
      </header>

      <div className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <h5>Hello There!</h5>
          <button className="btn-close" onClick={toggleSidebar} aria-label="Close"></button>
        </div>
        <ul className="sidebar-menu">
          <li><Link to="/" onClick={closeSidebar}>Home</Link></li>
          <li><Link to="/category" onClick={closeSidebar}>binzal Combo</Link></li>
          <li><Link to="/fruits-vegetables" onClick={closeSidebar}>All Vegetables</Link></li>
          <li><Link to="/my-orders" onClick={closeSidebar}>My Orders</Link></li>
          <li><Link to="/policy" onClick={closeSidebar}>Privacy Policy</Link></li>
          <li><Link to="/contact" onClick={closeSidebar}>Contact Us</Link></li>
        </ul>
      </div>

      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}
    </>
  );
}

export default Navbar;  
